import { ActivitySearchRequest } from '@trukt/tms-api/ActivityService';
import { createKey } from './createKey';

const keyHandler = createKey('activity');

export const ActivityKeys = {
  key: keyHandler.key,
  search: keyHandler.createMethod<ActivitySearchRequest>(),
};
